import { Component, EventEmitter, Input, Output } from '@angular/core';
@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
})
export class IntroComponent {
  private _showOverlay = false;
  @Output() overlayClosedEvt = new EventEmitter<boolean>();

  constructor() {}

  @Input() get showOverlay(): boolean {
    return this._showOverlay;
  }

  set showOverlay(showOverlay: boolean) {
    this._showOverlay = showOverlay;
  }

  public async handleOverlayOpened(): Promise<void> {
    const video = document.getElementById('intro') as HTMLVideoElement;
    // Simulate autoplay event (because autoplay attribute does not work always...)
    video.pause();
    video.currentTime = 0;
    await video.play();
  }

  public handleOverlayClosed(): void {
    this.overlayClosedEvt.emit(true);
  }
}
